export const isEmpty = (value: string | null | undefined) => {
  return (
    value == null ||
    (typeof value === "string" && value.trim() === "") ||
    (typeof value === "object" && Object.keys(value as object).length === 0)
  );
};
